/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeV2BackToTopData } from './moe-v2-back-to-top.data';
import { IMoeV2BackToTopProps } from './moe-v2-back-to-top.props.autogenerated';

export interface IMoeV2BackToTopViewProps extends IMoeV2BackToTopProps<IMoeV2BackToTopData> {}

/**
 *
 * MoeV2BackToTop component
 * @extends {React.PureComponent<IMoeV2BackToTopProps<IMoeV2BackToTopData>>}
 */
class MoeV2BackToTop extends React.PureComponent<IMoeV2BackToTopProps<IMoeV2BackToTopData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2BackToTop;
